export const SPORT_OPTIONS = [
  "Men's Basketball",
  "Women's Basketball",
  "Football",
  "Baseball",
  "Softball",
  "Soccer",
  "Volleyball",
  "Track & Field",
  "Cross Country",
  "Swimming & Diving",
  "Tennis",
  "Golf",
  "Lacrosse",
  "Hockey",
];
